module.exports = __webpack_public_path__ + "static/media/gp.ecc4250f.svg";